import React, { useEffect, useRef, useState } from 'react';
import { useStores } from '@/store';
import { getQuery } from '../../service/http';
import { Footer } from '@/components';
import { safeVal } from '../../service/utils'
import './index.less';

const cloneScriptNode = (script) => {
  const nextScript = document.createElement('script');

  Array.from(script.attributes).forEach(({ name, value }) => {
    nextScript.setAttribute(name, value);
  });

  nextScript.text = script.text || script.textContent || '';

  return nextScript;
};

const DynamicPage = () => {
  const { pageName, region, regionId, region_id } = getQuery();
  const { CommonStore } = useStores();
  const [pageHtml, setPageHtml] = useState('');
  const pageRef = useRef(null);

  useEffect(() => {
    CommonStore.getPageContent(safeVal(region, regionId, region_id), pageName).then(
      (res) => {
        setPageHtml(res?.data?.content || '');
      }
    );
  }, [CommonStore, pageName, region, regionId, region_id]);

  useEffect(() => {
    const container = pageRef.current;

    if (!container) {
      return undefined;
    }

    let disposed = false;

    const renderContent = async () => {
      container.innerHTML = '';

      if (!pageHtml) {
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.innerHTML = pageHtml;

      const scripts = Array.from(wrapper.querySelectorAll('script'));
      const markers = scripts.map(() => document.createElement('span'));

      scripts.forEach((script, index) => {
        const marker = markers[index];
        marker.setAttribute('data-dynamic-script-marker', String(index));
        script.parentNode?.replaceChild(marker, script);
      });

      while (wrapper.firstChild) {
        container.appendChild(wrapper.firstChild);
      }

      for (let index = 0; index < scripts.length; index += 1) {
        if (disposed) {
          return;
        }

        const currentMarker = markers[index];

        if (!currentMarker.parentNode) {
          continue;
        }

        const nextScript = cloneScriptNode(scripts[index]);

        await new Promise((resolve) => {
          if (nextScript.src) {
            nextScript.onload = resolve;
            nextScript.onerror = resolve;
          } else {
            resolve();
          }

          currentMarker.parentNode.replaceChild(nextScript, currentMarker);
        });
      }
    };

    renderContent();

    return () => {
      disposed = true;
      container.innerHTML = '';
    };
  }, [pageHtml]);

  return (
    <div className="hasFooterContent">
      <div
        ref={pageRef}
        className='dynamicPage'
      ></div>
      <Footer  hasMore={/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)}/>
    </div>
  );
};

export default DynamicPage;
